import axios from "../axios";

export async function fetchHseEvents(controller) {
  return axios({
    method: "get",
    url: "/hse_events",
    params: controller,
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

export async function fetchHseEvent(id) {
  return axios.get(`/hse_events/${id}`);
}

export async function createHseEvent(payload) {
  return axios
    .post("/hse_events", { hse_event: payload })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
}

export async function updateHseEvent(payload) {
  const id = typeof payload === "string" ? payload : payload.id;
  return axios
    .put(`/hse_events/${id}`, { hse_event: payload })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
}

export async function deleteHseEvent(payload) {
  const id = typeof payload === "string" ? payload : payload.id;
  return axios
    .delete(`/hse_events/${id}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
}

export async function submitHseEvent(payload) {
  const id = typeof payload === "string" ? payload : payload.id;
  return axios
    .post(`/hse_events/${id}/submit`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
}

export async function closeHseEvent(payload) {
  const id = typeof payload === "string" ? payload : payload.id;
  return axios
    .post(`/hse_events/${id}/close`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
}

export async function fetchHseEventStatistics() {
  return axios
    .get("/hse_events/statistics")
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

export async function printHseEvent(payload) {
  const id = typeof payload === "string" ? payload : payload.id;
  return axios.post(`/hse_events/${id}/print`, {
    ...payload,
    type: "application/pdf",
  });
}

export async function exportHseEventPDF(id) {
  return axios.get(`/hse_events/${id}/export_pdf`, {
    responseType: 'blob',
  });
}

export async function createHseAction(eventId, actionData) {
  return axios
    .post(`/hse_events/${eventId}/create_action`, { hse_action: actionData })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
}
